export enum STATUS_FILTER_VALUES {
  EMPTY = '',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  NA = 'NA',
}

export enum PUBLISHED_FILTER_VALUES {
  EMPTY = '',
  YES = 'YES',
  NO = 'NO',
}
